import axios from "axios";
import { ADMIN_API_URL } from "../config/serviceConstant";

export const getServiceAuthUrl = async (body, service) => {
  try {
    const config = {
      method: "POST",
      url: ADMIN_API_URL + "/auth/authenticator/authenticate",
      data: {
        orgId: body?.orgId,
        apiKey: body?.apiKey,
        zapiKey: body?.zapiKey,
        accountsUrl: service?.authorizeUrl,
        connName: service?.connName,
        scope: service?.scope,
        redirectUrl: ADMIN_API_URL + "/auth/authenticator/callback",
        crmApiDomain: service?.crmApiDomain,
        clientId: service?.clientId,
        authType: service?.authType,
        clientSecret: service?.clientSecret,
        scopeSeperator: service?.scopeSeperator,
        settingId: service?.settingId,
        queryParams: service?.queryParams,
      },
      params: service?.queryParams,
    };
    console.log({ body, service, config });

    const authUrlResp = await axios(config);
    return authUrlResp?.data?.authUrl;
  } catch (error) {
    return null;
  }
};

export const checkServiceAuth = async (serviceHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/authenticator/verifyauth",
      headers: serviceHeaders,
    };

    const authCheck = await axios(config);

    console.log({ authCheck });
    if (authCheck?.data?.data) {
      return true;
    }
    return false;
  } catch (error) {
    return false;
  }
};

export const revokeService = async (serviceHeaders) => {
  try {
    const config = {
      method: "get",
      url: ADMIN_API_URL + "/auth/authenticator/revoke",
      headers: serviceHeaders,
    };

    const revokeCheck = await axios(config);
    if (revokeCheck?.data || !revokeCheck?.error) return true;
    return false;
  } catch (error) {
    return false;
  }
};

export const authenticateService = async ({ serviceApiKey, headers }) => {
  return true;
  // const config = {
  //   url: ADMIN_API_URL + "/auth/" + SERVICE_NAME + "/authenticate",
  //   method: "post",
  //   data: {
  //     serviceApiKey: serviceApiKey,
  //   },
  //   headers: headers,
  // };
  // console.log({config});
  // const authServiceResp = await axios(config);
  // console.log({authServiceResp});
  // if (authServiceResp?.data?.data) {
  //   return true;
  // }
  // return false;
};

export const getAllConnections = async ({ headers }) => {
  try {
    const config = {
      url: ADMIN_API_URL + "/utils/connections",
      method: "get",
      headers: headers,
    };
    console.log({ config });
    const authServiceResp = await axios(config);
    console.log({ authServiceResp });
    return authServiceResp?.data?.tokenResps;
  } catch (error) {}
};

export const revokeAllConnections = async ({ headers }) => {
  try {
    const config = {
      url: ADMIN_API_URL + "/utils/revokeconnections",
      method: "get",
      headers: headers,
    };
    console.log({ config });
    const authServiceResp = await axios(config);
    console.log({ authServiceResp });
    return authServiceResp?.data?.tokenResps;
  } catch (error) {}
};

export const sendInvitalionLink = async ({ zApiKey, data }) => {
  let url = `https://www.zohoapis.com/crm/v2/functions/easyauthenticator__send_invitation_mail/actions/execute?auth_type=apikey&zapikey=${zApiKey}`;
  try {
    const config = {
      url: url,
      method: "post",
      headers: {
        "Content-type": "application/json",
      },
      data: data,
    };

    console.log({ config });
    const sendInviationResp = await axios(config);
    console.log({ sendInviationResp });
    return sendInviationResp;
  } catch (error) {
    console.log({ error });
  }
};
